module.exports = __webpack_public_path__ + "static/img/Home Appliance.06eedd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Home Appliance.jpg
// module id = nnGw
// module chunks = 1